import { API } from "aws-amplify";
import { getOffer } from "~/graphql/queries";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";

export const EMPTY_OFFER: APITypes.Offer = {
  __typename: "Offer",
  id: "",
  status: APITypes.OfferStatusType.Pending,
  rent: 0,
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getOfferDetails = async (
  id: string
): Promise<LoaderData<APITypes.Offer>> => {
  try {
    const response = (await API.graphql({
      query: getOffer,
      variables: {
        id,
      },
    })) as { data?: APITypes.GetOfferQuery };

    return {
      success: true,
      data: response.data?.getOffer || EMPTY_OFFER,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_OFFER,
      error,
    };
  }
};
